import createReducer from "@utils/createReducer";
import * as types from "../types/index";
const initialState = {
  filters: {
    project: null,
    user: null,
    deviance: null,
    category: null,
    checkList: null,
    planning: null,
    hours: null,
    holidays: null,
    attendance: null,
    storage: null,
    employeeReport: null,
    planSchedule: null,
    dashboard: null,
    userManagement: null,
    rules: null,
    staffing: null,
    approval: null,
  },
};

export const commonReducer = createReducer(initialState, {
  [types.FILTER_DATA](state, action) {
    const { page, params } = action.payload;
    if (params) {
      return Object.assign({}, state, {
        ...state,
        filters: {
          ...state.filters,
          [page]: { ...state.filters[page], ...params },
        },
      });
    } else {
      return Object.assign({}, state, {
        ...state,
        filters: {
          ...state.filters,
          [page]: null,
        },
      });
    }
  },
});
